<script setup lang="ts">

interface Props {
  titles: string[] | null
  subtitle?: string | null | undefined
}

defineProps<Props>()
</script>

<template>
<!--  <section class="UiHero">-->
<!--    <img class="UiHero__image" src="@/assets/img/card.png" ondragstart="return false" alt="card" />-->
<!--    <div class="UiHero-wrapper" v-if="titles?.length">-->
<!--      <div class="UiHero-info">-->
<!--        <h2 v-for="title in titles" class="UiHero-info__title">{{ title }}</h2>-->

<!--        <h3-->
<!--          v-if="subtitle"-->
<!--          class="UiHero-info__description"-->
<!--          :class="{-->
<!--            'UiHero-info__description&#45;&#45;description': false-->
<!--          }"-->
<!--        >-->
<!--          Итого: {{ subtitle }}-->
<!--        </h3>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->
  <section class="UiHero container">
    <div class="UiHero__meta">
      <h1 v-for="(title, i) in titles" :key="i" class="UiHero__title">
        {{ title }}
      </h1>
    </div>
    <p v-if="subtitle" class="UiHero__price">{{ subtitle }}</p>
  </section>
</template>

<style lang="scss" scoped>
h1, h2, h3, h4 {
  margin-bottom: 0;
}

.UiHero {
  display: flex;
  column-gap: 20px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: fluid(40, 32);
  border-radius: var(--rounded-xxl);
  background: var(--color-bg-banner);
  padding-block: 40px;

  @include mobile {
    flex-direction: column;
    align-items: start;
    row-gap: 12px;
    padding: 20px 14px;
    max-width: calc(100% - 4px);
  }

  &__meta {
    display: flex;
    row-gap: fluid(16, 8);
    flex-direction: column;
    max-width: 668px;
  }

  &__subtitle {
    opacity: 0.6;
    font-weight: 600;
    font-size: fluid(20, 16);
    line-height: 1.35;
  }

  &__price {
    color: var(--color-accent-alt);
    font-weight: 700;
    font-size: fluid(28, 22);
  }
}
</style>
